import React from 'react';
import translate from '../locales/intro';
import Button from '../components/button';
import Img from '../components/image';
import gif from '../assets/images/gif/velo.gif';

function Intro() {
    return (
        <div className="intro ">
        <div className="large container medium-padding-vertical">
            <p className="purple large-text text-center">{translate.content}</p>
            <p className="text-center">
            <Button text={translate.button} link={translate.link} target="_blank" rel="noreferrer"/>
            </p>
            <div className="cols-2">
                
                <div className="content-left">
                    <div>
                        <h2 className="purple">{translate.vision.title}</h2>
                        <p>{translate.vision.content}</p>
                    </div>
                    <div>
                        <h2 className="purple">{translate.who.title}</h2>
                        <p>{translate.who.content}</p>
                    </div>
                </div>
                <Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" src={gif} alt={translate.gif.alt} legend={translate.gif.legend}/>
            </div>
            </div>
        </div>
    )
}

export default Intro;